import React, { useEffect, useState } from "react";
import "../css/PageEditor.css";
import SectionCard from "./SectionCard";

function PageEditor() {

  const [page, setPage] = useState("home");
  const [sections, setSections] = useState([]);
   const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    fetchPage(); 
   
  }, [page]);

  const fetchPage = async () => {
    setLoading(true);
    setError("");
  try {
    const res = await fetch(
      "/api/page-config/page-editor/" + page
    );

    const data = await res.json();
   console.log("RAW SECTIONS:", JSON.stringify(data.sections, null, 2));
    // console.log("API DATA:", data);
    //  console.log("SECTION FIELDS:", data.sections);

    setSections(data.sections || []);

  } catch (err) {
    console.error("Fetch error:", err);
    setError("Failed to load page. Please try again");
  } finally {
    setLoading(false);
  }
};

const runSync = async () => {
  await fetch("/api/page-config/sync", {
    method: "POST"
  }).then(() => alert("Synced!"));
};



  return (
    <div className="pageEditorContainer">

      <div className="pageEditorHeader">

        <h2>Page Editor</h2>

        <select
          className="pageDropdown"
          value={page}
          onChange={(e) => setPage(e.target.value)}
        >
          <option value="home">Home Page</option>
          <option value="nfirst">N-First Page</option>
          <option value="diplos">Diplos Page</option>
          <option value="dealer">Become a Dealers Page</option>
          <option value="locateDealer">Locate a Dealer Page</option>
          <option value="privacyPolicy">Privacy Policy</option>
          <option value="refundPolicy">Refund Policy</option>
          <option value="termsConditions">Terms & Conditions</option>
          <option value="contactUs">Contact Us Page</option>
          <option value="careers">Careers Page</option>
          <option value="testRide">Book a Test Ride</option>
          <option value="bookNow">Book Now</option>
          <option value="emi">EMI Calculator Page</option>
          <option value="savings">Savings Calculator Page</option>
          <option value="login">Login/OTP/Order Page</option>
          <option value="blogs">Blogs Page</option>
          <option value="commonTestRide">Common Test Ride Page</option>
          <option value="commonBookNow">Common Book Now Page</option>
          {/* <option value="about">About Page</option> */}
        </select>

        <button onClick={() => runSync()}>Refresh</button>

      </div>

        {/* LOADING */}
      {loading && <p className="loadingText">Loading...</p>}

      {/* ERROR */}
      {error && <p className="errorText">{error}</p>}

     

        {!loading && (
           <div className="sectionsContainer">
          {sections.length === 0 && (
            <p className="emptyText">No sections found.</p>
          )}
        

        {sections.map((section) => (
          <SectionCard key={section.id} section={section} page={page} onSaved={fetchPage} />
        ))}

      </div>
        )}
    </div>
  );
}

export default PageEditor;